export const logo = (theme) => ({
    logo: {
        cursor: "pointer",
        height: "126px !important",
        width: "100% !important",
        [theme.breakpoints.down("sm")]: {
            height: "60px !important",
            margin: "auto",
        },
    },
});
